import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-ink px-5">
      <div className="w-full max-w-sm bg-white p-8 border border-ink">
        <div className="flex items-baseline gap-1 mb-1">
          <span className="font-display font-black text-2xl tracking-tighter">GO</span>
          <span className="font-display font-black text-2xl tracking-tighter text-brand">BIG</span>
        </div>
        <p className="text-sm text-muted-foreground mb-6 flex items-center gap-2"><Lock size={14} /> Admin portal</p>
        <form onSubmit={submit} className="space-y-4">
          <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" className="w-full border-b border-ink/30 focus:border-brand outline-none bg-transparent py-2" />
          <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" className="w-full border-b border-ink/30 focus:border-brand outline-none bg-transparent py-2" />
          {error && <p className="text-brand text-sm" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="login-submit">
            {loading ? <Loader2 size={18} className="animate-spin" /> : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
